import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { PublicSite } from './pages/PublicSite'
import { PrivacyPolicy, TermsOfService } from './pages/LegalPage'

const Admin = lazy(() => import('./pages/Admin').then((module) => ({ default: module.Admin })))

export default function App() {
  return (
    <Routes>
      <Route path="/admin" element={<Suspense fallback={<div className="admin-loading"><div className="admin-loading__mark">BR</div><span>Loading studio…</span></div>}><Admin /></Suspense>} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/" element={<PublicSite />} />
      <Route path="/lander" element={<Navigate to="/" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
